import { useTranslations } from 'next-intl';
import {
  ContentLayout,
  TransporterPageContent,
} from '@silvertours/common-landingpages-view';
import {
  BenefitsLegacy,
  StageLegacy,
  ContentArticle,
  SerpOffersModule,
} from '@silvertours/front-features';
import { useRawFeatureTranslations } from '@silvertours/front-shared';

import { Body } from '../body';

const TransporterContent = ({
  content: {
    article,
    globalRating,
    introduction,
    links,
    location,
    offersByCategory,
    stage,
    textContent: { primaryHeadline },
  },
  ...commonProps
}: ContentLayout<TransporterPageContent>) => {
  const translations = useRawFeatureTranslations('article');
  const carTypes = useRawFeatureTranslations('offers.car.type');
  const offersTranslations = useTranslations('features.offers');

  return (
    <Body
      variant={{ kind: 'default' }}
      bodyTop={
        <StageLegacy.Stage
          content={stage.content}
          headline={primaryHeadline}
          variant={{ kind: 'default' }}
        />
      }
      searchData={stage?.content?.search}
      content={({ container, containerModule, contentModule }) => [
        containerModule(
          'usp',
          <BenefitsLegacy.Usp rating={globalRating.content} />,
        ),
        containerModule(
          'introduction-content',
          <ContentArticle
            modules={introduction?.segments ?? []}
            translations={translations}
          />,
          !!introduction?.segments,
        ),
        containerModule(
          'serpOffers',
          !!offersByCategory.content && (
            <SerpOffersModule
              content={offersByCategory.content}
              translations={{
                airConditioning: offersTranslations('car.airConditioning'),
                carTypes,
                prevText: offersTranslations('prevText'),
                nextText: offersTranslations('nextText'),
                ariaLabel: offersTranslations('ariaLabel'),
                searchButtonText: offersTranslations(
                  'searchButtonTextTransporter',
                ),
                disclaimertext: offersTranslations('disclaimerSerpOffers'),
                pricePrefix: offersTranslations('pricePrefix'),
                priceSuffix: offersTranslations('priceSuffix'),
                serpTitle: location.name
                  ? offersTranslations(
                      'serp.title.transporterDestination',
                    ).replace('%LOCATION%', location.name)
                  : offersTranslations('serp.title.transporter'),
                seats: offersTranslations('car.seats'),
                doors: offersTranslations('car.doors'),
                transmission: offersTranslations('car.transmission'),
                transmissionAutomatic: offersTranslations(
                  'car.transmissionAutomatic',
                ),
                transmissionManual: offersTranslations(
                  'car.transmissionManual',
                ),
              }}
              searchQuery={new URLSearchParams({
                car_class: 'truck',
              }).toString()}
            />
          ),
          !!offersByCategory.content &&
            Object.keys(offersByCategory.content).length > 0,
        ),
        container('content-modules', [
          contentModule(
            'article',
            <ContentArticle
              modules={article.segments}
              translations={translations}
              searchQuery={new URLSearchParams({
                car_class: 'truck',
              }).toString()}
            />,
          ),
        ]),
        containerModule(
          'linkLists',
          <ContentArticle
            modules={links.content ?? []}
            translations={translations}
          />,
          !!links.content.length,
        ),
      ]}
      {...commonProps}
    />
  );
};

export { TransporterContent };
